export const RESET_GET_GLOBAL_VARIANT_FORM = 'RESET_GET_GLOBAL_VARIANT_FORM'

export const GET_ALL_GLOBAL_VARIANTS = 'GET_ALL_GLOBAL_VARIANTS'
export const GET_GLOBAL_VARIANT_FORM = 'GET_GLOBAL_VARIANT_FORM'
export const SUBMIT_GLOBAL_VARIANT_FORM = 'SUBMIT_GLOBAL_VARIANT_FORM'
export const DELETE_GLOBAL_VARIANT = 'DELETE_GLOBAL_VARIANT'
